import { Types } from './types'

const initialState = {
    dataCategory: [],
    dataPost: {
        rows: [],
        paging: {}
    },
    dataPostCategory: {
        rows: [],
        paging: {}
    },
    dataPostAgency: {
        rows: [],
        paging: {}
    },
    dataAgencyPost: {
        rows: [],
        paging: {}
    },
    dataTag: [],
    dataAllTag: [],
    dataAuthorCMS: {
        paging: {},
        rows: [],
    },
    dataExpertCMS: {
        paging: {},
        rows: [],
    },
    dataCategorySEO: {
        paging: {},
        rows: []
    }
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_CATEGORY:
            return {
                ...newState,
                dataCategory: action.payload
            }
        case Types.SAVE_LIST_POST:
            return {
                ...newState,
                dataPost: action.payload
            }
        case Types.SAVE_LIST_POST_AGENCY:
            return {
                ...newState,
                dataPostAgency: action.payload
            }

        case Types.SAVE_LIST_AGENCY_POST:
            return {
                ...newState,
                dataAgencyPost: action.payload
            }
        case Types.SAVE_LIST_POST_CATEGORY:
            return {
                ...newState,
                dataPostCategory: action.payload
            }
        case Types.SAVE_LIST_TAG:
            return {
                ...newState,
                dataTag: action.payload
            }
        case Types.SAVE_ALL_TAG:
            return {
                ...newState,
                dataAllTag: action.payload
            }
        case Types.SAVE_LIST_AUTHOR_CMS:
            return {
                ...newState,
                dataAuthorCMS: action.payload
            }
        case Types.SAVE_LIST_EXPERT_CMS:
            return {
                ...newState,
                dataExpertCMS: action.payload
            }
        case Types.SAVE_LIST_CATEGORY_SEO_CMS:
            return {
                ...newState,
                dataCategorySEO: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
